var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-header",class:{ 'page-header--without-margin': _vm.noMargin }},[_vm._t("default",function(){return [_c('h1',{staticClass:"page-header__title"},[_vm._v(_vm._s(_vm.$te(_vm.title) ? _vm.$t(_vm.title) : _vm.title))])]}),_c('div',{staticClass:"page-header__actions"},[_vm._t("actions")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }